import { LoadingPage } from "@components/LoadingPage";
import { Redirect } from "@components/Redirect";
import React from "react";

import { Username } from "@every.org/common/src/codecs/username";
import {
  ClientRouteName,
  getRoutePath,
  URLFormat,
} from "@every.org/common/src/helpers/clientRoutes";

import { useUser } from "src/context/UsersContext/hooks";
import { FETCHING_USER, USER_NOT_FOUND } from "src/context/UsersContext/types";
import { NotFoundPage } from "src/pages/NotFound";

export const RedirectToUserOrNotFound: React.FCC<{ username: Username }> = ({
  username,
}) => {
  const user = useUser({ username: username });

  if (user === FETCHING_USER) {
    return <LoadingPage />;
  }
  if (user === USER_NOT_FOUND) {
    return <NotFoundPage />;
  }
  return (
    <Redirect
      to={getRoutePath({
        format: URLFormat.RELATIVE,
        name: ClientRouteName.USER,
        tokens: { username: username },
      })}
    />
  );
};
